var map = {
	"./border_2.png": 827,
	"./border_3.png": 994,
	"./bordercorner_1.png": 67,
	"./bordercorner_2.png": 456,
	"./bordercorner_3.png": 585,
	"./bordercorner_4.png": 102,
	"./doorway.png": 513,
	"./tile_1.png": 118,
	"./tile_2.png": 221,
	"./tile_3.png": 332,
	"./tile_4.png": 499
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 665;